<template>
  <div
    :class="compact
      ? 'flex items-center gap-4'
      : 'flex items-start gap-6 px-6 py-4'"
  >
    <div class="flex min-w-0 flex-col gap-0.5">
      <span class="text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        {{ syncLabel }}
      </span>
      <time
        v-if="syncedAt"
        :datetime="syncedAt"
        class="text-sm font-medium text-green-700"
      >
        {{ formatDateTime(syncedAt) }}
      </time>
      <span
        v-else
        class="text-sm font-medium text-red-700"
      >
        {{ emptySyncLabel }}
      </span>
    </div>
    <div
      class="flex min-w-0 flex-col gap-0.5 border-l border-gray-200"
      :class="compact ? 'pl-4' : 'pl-6'"
    >
      <span class="text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        {{ editLabel }}
      </span>
      <time
        v-if="updatedAt"
        :datetime="updatedAt"
        class="text-sm text-gray-700"
      >
        {{ formatDateTime(updatedAt) }}
      </time>
      <span
        v-else
        class="text-sm text-gray-400"
      >
        —
      </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  syncedAt: {
    type: String,
    default: null,
  },
  updatedAt: {
    type: String,
    default: null,
  },
  syncLabel: {
    type: String,
    default: 'Medfile',
  },
  editLabel: {
    type: String,
    default: 'Edycja',
  },
  emptySyncLabel: {
    type: String,
    default: 'Brak synchronizacji',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

function formatDateTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pl-PL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}
</script>
